import store from '@/store/index.js'
let dic = store.state.dic;

export default function Configs(that) {

    const searchItems = [
        {
            label: "用户名",
            span: 8,
            model: "userId",
        },
    ]
    const tableColumns = [
        {
            label: "用户id",
            prop: "userId",
            align: "center",
            show: true,
            minWidth: 200,
        },
        {
            label: "ip地址",
            prop: "ip",
            align: "center",
            show: true,
            minWidth: 160,
        },
        {
            label: "端口号",
            prop: "port",
            align: "center",
            show: true,
        },
        {
            label: "访问路径",
            prop: "path",
            align: "center",
            show: true,
            minWidth: 400,
        },
        {
            label: "参数",
            prop: "params",
            align: "center",
            show: true,
            minWidth: 200,
        },
        {
            label: "操作时间",
            prop: "createTime",
            align: "center",
            show: true,
            width: '180px',
        },
    ]

    return {
        searchItems,
        tableColumns,
    }
}